// lib/constants/contactFields.js
import React from "react";
import { ReferrerSource } from "@prisma/client";
import {
    Building,
    Calendar,
    CheckSquare,
    Globe,
    Hash,
    Image,
    Info,
    List,
    Mail,
    MailWarning,
    Map,
    MapPin,
    MessageCircle,
    Phone,
    Type,
    User,
    Wrench,
} from "lucide-react";

export const NAME = "name";
export const EMAIL = "email";
export const PHONE = "phone";
export const MESSAGE = "message";
export const COMPANY = "company";
export const FULL_ADDRESS = "full_address";
export const CITY = "city";
export const STATE = "state";
export const COUNTRY = "country";
export const POSTAL_CODE = "postal_code";
export const REFERRAL_SOURCE = "referral_source";
export const DISCLAIMER_TEXT = "disclaimer_text";
export const TEXT = "text";
export const OPTIONS = "options";
export const SELECT = "select";
export const DATETIME = "datetime";
export const IMAGE = "image";
export const SERVICES = "services";

export const ICONS = {
  [NAME]: <User />,
  [EMAIL]: <Mail />,
  [PHONE]: <Phone />,
  [MESSAGE]: <MessageCircle />,
  [COMPANY]: <Building />,
  [FULL_ADDRESS]: <MapPin />,
  [CITY]: <Map />,
  [STATE]: <Map />,
  [COUNTRY]: <Globe />,
  [POSTAL_CODE]: <Hash />,
  [REFERRAL_SOURCE]: <Info />,
  [DISCLAIMER_TEXT]: <MailWarning />,
  [TEXT]: <Type />,
  [OPTIONS]: <CheckSquare />,
  [SELECT]: <List />,
  [DATETIME]: <Calendar />,
  [IMAGE]: <Image />,
  [SERVICES]: <Wrench />,
};

const CONTACT_FIELDS = [
  {
    key: NAME,
    label: "Name",
    fieldType: "text",
    mandatory: true,
    required: true,
    value: "",
  },
  {
    key: EMAIL,
    label: "Email",
    fieldType: "email",
    mandatory: true,
    required: true,
    value: "",
  },
  {
    key: PHONE,
    label: "Phone",
    fieldType: "tel",
    mandatory: false,
    required: true,
    value: "",
  },
  {
    key: FULL_ADDRESS,
    label: "Full Address",
    fieldType: "text",
    mandatory: false,
    required: false,
    value: "",
  },
  {
    key: SERVICES,
    label: "Which services are you interested in?",
    shortLabel: "Services",
    fieldType: "services",
    required: false,
    mandatory: false,
    value: [],
    options: [],
  },
  {
    key: MESSAGE,
    label: "Leave us a message",
    fieldType: "textarea",
    mandatory: false,
    required: false,
    value: "",
  },
  {
    key: COMPANY,
    label: "Company",
    fieldType: "text",
    mandatory: false,
    required: false,
    value: "",
  },
  {
    key: CITY,
    label: "City",
    fieldType: "text",
    mandatory: false,
    required: false,
    value: "",
  },
  {
    key: STATE,
    label: "State",
    fieldType: "text",
    mandatory: false,
    required: false,
    value: "",
  },
  {
    key: COUNTRY,
    label: "Country",
    fieldType: "text",
    mandatory: false,
    required: false,
    value: "",
  },
  {
    key: POSTAL_CODE,
    label: "Postal Code",
    fieldType: "text",
    mandatory: false,
    required: false,
    value: "",
  },
  {
    key: REFERRAL_SOURCE,
    label: "How did you hear about us?",
    fieldType: "text",
    mandatory: false,
    required: false,
    value: "",
  },
  {
    key: DISCLAIMER_TEXT,
    label: "Disclaimer Text",
    fieldType: "disclaimer_text",
    mandatory: false,
    required: false,
    value: "",
  },
];

const CUSTOM_FIELDS = [
  {
    key: TEXT,
    label: "Text",
    fieldType: "text",
    required: false,
    value: "",
    mandatory: false,
  },
  {
    key: OPTIONS,
    label: "Options",
    fieldType: "options",
    value: [],
    options: [],
    required: false,
    mandatory: false,
  },
  {
    key: SELECT,
    label: "Select",
    fieldType: "select",
    required: false,
    value: [],
    options: [],
    mandatory: false,
  },
  {
    key: DATETIME,
    label: "Date/Time",
    fieldType: "datetime",
    required: false,
    value: "",
    mandatory: false,
  },
  {
    key: IMAGE,
    label: "Image",
    fieldType: "image",
    required: false,
    mandatory: false,
    value: "",
  },
];

const NON_MANDATORY_FIELDS = CONTACT_FIELDS.filter((field) => {
  return !field.mandatory;
});

const MANDATORY_FIELDS = CONTACT_FIELDS.filter((field) => {
  return field.mandatory;
});

export const SKIP_VALIDATION_REFERRERS: ReferrerSource[] = [
  ReferrerSource.WIDGET_AD,
  ReferrerSource.OFFER,
  ReferrerSource.AD,
  ReferrerSource.WIDGET_GENERAL,
  ReferrerSource.EMBED_FORM,
];

export default CONTACT_FIELDS;

export { CUSTOM_FIELDS, MANDATORY_FIELDS, NON_MANDATORY_FIELDS };
